/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import './style/colorPicker.scss';

import React from 'react';
import {MouseEventHandler, PureComponent} from 'react';
import {
    BlockPicker, ChromePicker, CirclePicker, Color, ColorPickerProps, ColorResult, CompactPicker, PhotoshopPicker,
    SketchPicker, TwitterPicker,
} from "react-color";
import {ColorPickerResultType, ColorPickerType} from "../util/interfaces";
import WithBackground from "../popup/withBackground";
import {Button} from "../../../index";

interface Props extends ColorPickerProps<any> {
    onSubmit: (color: Color) => void;
    onPreChange?: (color: Color) => void;
    onClose: MouseEventHandler;
    pickerType: ColorPickerType;
    resultType: ColorPickerResultType;
    visible: boolean;
    transparent: boolean;
    closeable: boolean;
}

interface State {
    color: Color;
}

export default class ColorPicker extends PureComponent<Props, State> {
    static defaultProps = {
        pickerType: ColorPickerType.SKETCH,
        resultType: ColorPickerResultType.HEX,
        transparent: false,
        closeable: true,
    };

    state: State = {
        color: this.props.color || '#000',
    };

    onSubmit = () => {
        const {onSubmit} = this.props, {color} = this.state;
        onSubmit(color);
    };

    onChange = (color: ColorResult) => {
        let newColor: Color;
        switch (this.props.resultType) {
            case ColorPickerResultType.HEX:
                newColor = color.hex;
                break;
            case ColorPickerResultType.HSL:
                newColor = color.hsl;
                break;
            case ColorPickerResultType.RGB:
                newColor = color.rgb;
                break;
        }
        this.setState({color: newColor});
    };

    onPreChange = (color: ColorResult) => {
        const {onPreChange} = this.props;
        if (!onPreChange) return;
        switch (this.props.resultType) {
            case ColorPickerResultType.HEX:
                onPreChange(color.hex);
                break;
            case ColorPickerResultType.HSL:
                onPreChange(color.hsl);
                break;
            case ColorPickerResultType.RGB:
                onPreChange(color.rgb);
                break;
        }
    };

    getPicker = () => {
        const {pickerType} = this.props, {color} = this.state,
            props = {color, onChangeComplete: this.onChange, onChange: this.onPreChange};
        switch (pickerType) {
            case ColorPickerType.BLOCK:
                return <BlockPicker {...props}/>;
            case ColorPickerType.CHROME:
                return <ChromePicker {...props}/>;
            case ColorPickerType.CIRCLE:
                return <CirclePicker {...props}/>;
            case ColorPickerType.COMPACT:
                return <CompactPicker {...props}/>;
            case ColorPickerType.PHOTOSHOP:
                return <PhotoshopPicker {...props}/>;
            case ColorPickerType.SKETCH:
                return <SketchPicker {...props}/>;
            case ColorPickerType.TWITTER:
                return <TwitterPicker {...props}/>;
            default:
                return <SketchPicker {...props}/>;
        }
    };

    render = () => {
        const {onClose, visible, transparent, className, closeable} = this.props;
        return (
            <WithBackground onClose={onClose} active={visible} transparent={transparent} backgroundClass={className}>
                <div className='color-picker-container'>
                    {this.getPicker()}
                    <div className='buttons-container'>
                        {closeable && <Button onClick={onClose} label='Sluit' type='outlined'/>}
                        <Button onClick={this.onSubmit} label='Kies' containerClass='submit-color'/>
                    </div>
                </div>
            </WithBackground>
        )
    };
}